import React from 'react';
import { Dialog } from 'cdk-radial';

const CANCEL = 'Cancel';
const PROCEED = 'Proceed';
const VARIANT_TEXT = 'text';

function Overlay({ active, title, onOverlayClose, onOverlayAccept, children, customeStyle, firstButtonText, secondButtonText, hideCloseButton, hideHeader, disableFirstButton, disableSecondButton, hideFirstButton, className, hideSecondButton}) {

  let firstButton = {
    id: 'dialog-action-1',
    onClick: onOverlayClose,
    text: firstButtonText || CANCEL,
    variant: VARIANT_TEXT,
    isDisabled: disableFirstButton,
  };
  
  let secondButton = {
    id: 'dialog-action-2',
    onClick: onOverlayAccept,
    text: secondButtonText || PROCEED,
    variant: VARIANT_TEXT,
    isDisabled: disableSecondButton
  };

  let buttons = [];

  if(!hideFirstButton) buttons.push(firstButton);

  if(!hideSecondButton) buttons.push(secondButton);
  
  return (
    <div>
      <Dialog
        style={customeStyle}
        isOpen={active}
        buttonsProps={buttons}
        closeLabel="Close"
        dataTestId="dialog"
        disableFocusTrap={false}
        hideCloseButton={hideCloseButton}
        hideHeader={hideHeader}
        id="overlay-id"
        isFullScreen={false}
        onClose={onOverlayClose}
        title={title}
        className={className}
      >
        {children}
      </Dialog>
    </div>
  );
}

export default Overlay;
